import React from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useSelector, useDispatch } from "react-redux";
import {
  toggleMobileExplore,
  toggleNav,
} from "../../store/features/modalSlice";
import { useNavigate } from "react-router-dom";

const NavPopup = ({
  onClose,
  subOptions,
  selectedName,
  openPopup,
  handleToggleNavigation,
  setFilters,
}) => {
  // console.log(selectedName, "->", subOptions);
  const { filterKey, selectedOption } = useSelector((state) => state.modal);
  const navigate = useNavigate();

  const selectedOptionHandler = (category, option) => {
    if (category === "hotelStayAndVenue") {
      setFilters((prevFilters) => ({
        ...prevFilters,
        hotelType: [option],
      }));
    } else if (category === "eventTypes") {
      setFilters((prevFilters) => ({
        ...prevFilters,
        eventTypes: option,
      }));
    } else {
      setFilters((prevFilters) => ({
        ...prevFilters,
        [category]: [option],
      }));
    }
  };

  const navigateHandler = (subOption, index) => {
    if (filterKey === "eventTypes") {
      const eventType = {
        [selectedOption.subKey[index]]: [subOption],
      };
      selectedOptionHandler(filterKey, eventType);
    } else {
      selectedOptionHandler(filterKey, subOption);
    }
    if (filterKey === "hotelStayAndVenue") {
      navigate("/listing/2");
    } else {
      navigate(`/listing/1`);
    }
    handleToggleNavigation();
  };

  return (
    <div
      className={`bg-white text-[#FE4747] overflow-auto fixed  right-0 z-50 w-full  transition-transform duration-300 ease-in-out ${
        openPopup ? "translate-x-0" : "translate-x-full"
      }`}
      style={{ top: "80px", height: "calc(100vh - 80px)" }}
    >
      <div
        onClick={onClose}
        className="flex  items-center gap-3 text-[16px] font-medium p-4 cursor-pointer"
      >
        <FaArrowLeftLong className="" /> Back
      </div>
      <div className="p-6">
        <h2 className="text-[20px] font-bold mb-8">{selectedName}</h2>
        <ul className="flex flex-col gap-5 pl-10">
          {subOptions.map((option, index) => (
            <li
              key={index}
              className="text-[16px] font-medium"
              onClick={() => navigateHandler(option, index)}
            >
              {option}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default NavPopup;
